import { StyledNeutralButton } from 'src/components/buttons/NeutralButton/NeutralButton.styles';
import { StyledAnimatedArrow } from 'src/components/common/AnimatedArrow/AnimatedArrow.styles';
import { IHiddenRanges } from 'src/interfaces/global';
import Flex from 'src/styles/layouts/Flex';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addHiddenRangesStyles, addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledNavLinksListItem = styled.li<{ isDisabled?: boolean } & IHiddenRanges>`
	${(p) => css`
		position: relative;

		display: flex;
		justify-content: center;
		align-items: center;

		flex-direction: column;

		${addHiddenRangesStyles(p)}

		& > p {
			font-size: 1rem;
		}

		& + li {
			margin-left: 40px;
		}

		& ${StyledNeutralButton} {
			z-index: 1;
		}

		@media (hover: hover) {
			&:hover ${StyledSublinkList} {
				max-height: 300px;
				opacity: 1;
			}
		}

		${mq('1300px', `& + li { margin-left: 20px; }`)}

		${mq(
			EMediaQuery.md,
			`
		order: 1;
		margin-top: 20px;

		& + li {
			margin-left: 0;
		}

		&:nth-last-child(1) {
			order: 0;
			margin-bottom: 20px;
		}
	`
		)}
	`}
`;

export const StyledMobileListItem = styled.li<{ isActive?: boolean } & IHiddenRanges>`
	${(p) => css`
		position: relative;
		cursor: pointer;

		display: flex;
		justify-content: center;
		align-items: center;

		flex-direction: column;

		width: 100%;

		${addHiddenRangesStyles(p)}

		& > button {
			position: relative;

			display: flex;
			justify-content: center;
			align-items: center;

			background-color: transparent;
			border: none;

			width: 90%;

			padding: 16px 0px;

			& ${StyledAnimatedArrow} {
				position: absolute;

				margin-left: 250px;

				${mq(EMediaQuery.xs, `margin-left: 200px;`)}
			}

			&::before {
				content: ' ';
				position: absolute;

				bottom: 0;

				width: 80%;
				height: 1px;

				background: linear-gradient(270deg, rgba(71, 71, 71, 0) 1.92%, #474747 49.48%, rgba(71, 71, 71, 0) 100%);
			}

			&::after {
				content: ' ';
				position: absolute;
				right: -15px;

				width: 4px;
				height: 4px;
			}

			&::before,
			&::after {
				${p.isActive ? `opacity: 1;` : ''}
			}
		}

		& > div {
			//width: 20px;
		}

		order: 1;

		&:nth-last-child(1) {
			order: 0;
			margin-bottom: 20px;
		}
	`}
`;

export const StyledSublinks = styled.ul`
	${(p) => css`
		position: relative;
		z-index: 205;

		width: 100%;

		margin-top: 24px;
		padding-top: 12px;
		padding-left: 12px;
		padding-right: 12px;
		padding-bottom: 12px;

		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;

		&:before {
			content: ' ';
			position: absolute;
			top: 1px;
			bottom: 1px;
			left: 1px;
			right: 1px;

			border-radius: inherit;

			background: linear-gradient(
				to bottom,
				#00000000 0%,
				${p.theme.colors.black}00 20px,
				${p.theme.colors.black} 60px,
				${p.theme.colors.black} 100%
			);
		}
	`}
`;

export const StyledSublinkList = styled.div`
	position: absolute;
	z-index: 0;
	top: 0;

	margin-top: -10px;

	display: flex;
	flex-direction: column;
	align-items: center;

	min-width: 130px;
	width: 100%;

	${addTransition()}

	opacity: 0;
	max-height: 0px;

	overflow: hidden;
`;

export const StyledBorderContainer = styled.span`
	${(p) => css`
		position: absolute;
		bottom: 0px;
		left: 0px;
		right: 0px;
		z-index: 100;

		height: calc(100% - 60px);

		background: linear-gradient(to top, ${p.theme.colors.gold} 0%, ${p.theme.colors.gold}00 100%);

		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
	`}
`;

export const FlexEx = styled(Flex)<{ isDisabled?: boolean }>`
	position: relative;

	${addTransition()}

	${(p) =>
		p.isDisabled
			? `opacity: 0.5;`
			: `
				@media (hover: hover) {
					&:hover {
						opacity: 0.7;
					}
				}
			  `}
`;

export const StyledNavbarLight = styled.div`
	position: absolute;
	top: -20px;
	z-index: -2;
	left: 0;
	width: 100vw;
	height: 100%;

	opacity: 0.8;
`;
